import { CommonLayout, CommonLayoutForInvestor } from '../commonComponents';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ViewFamily from '.';
import CreateFamily from './CreateFamily';
import FamilyMember from './FamilyMember'
import { useSelector } from 'react-redux';
import { USER_ROLES } from '../../utils/constant';
import FamilyProfileDetails from './FamilyProfileDetails';
import InvFamCheckRoute from './InvFamCheckRoute';
import LeaveFamily from './LeaveFamily';
import DynamicInvestorRoutes from './InvestorDynamicRouter';

const routerList = [
    {
        name: 'Inv Fam Route Check',
        path: "invFamRouteCheck",
        component: InvFamCheckRoute,
    },
    {
        name: 'View Families',
        path: "viewFamily",
        component: ViewFamily,
    },
    {
        name: 'Create Family',
        path: "createFamily",
        component: CreateFamily,
    },
    {
        name: 'Add Family Member',
        path: "addFamilyMember",
        component: CreateFamily,
    },
    {
        name: 'Family Details',
        path: "familyDetails",
        component: FamilyMember,
    },
    {
        name: 'Family Dashboard',
        path: "family-profile/:familyId",
        component: FamilyProfileDetails,
    },
    {
        name: 'View Family',
        path: 'leaveFamily',
        component: LeaveFamily
    },
    {
        name: 'Family Status',
        path: 'familyStatus',
        component: ViewFamily
    },
    {
        name: 'Family Member Dashboard',
        path: ':familyMemberName',
        component: DynamicInvestorRoutes
    }
]

function FamiliesRoutes(): JSX.Element {
    const { path } = useRouteMatch();

    return (
        <Switch>
            {
                routerList.map((item, index) => <Route
                    // exact
                    key={index}
                    path={`${path}/${item.path}`}
                    component={item.component}
                />)
            }
        </Switch>
    );
}

function FamilyRoleBasedLayout({ children }: { children: any }): JSX.Element {
    const { role } = useSelector((state: any) => state.auth);

    if (role === USER_ROLES.INVESTOR) {
        return (
            <CommonLayoutForInvestor>
                {children}
            </CommonLayoutForInvestor>
        )
    }
    else {
        return (
            <CommonLayout>
                {children}
            </CommonLayout>
        )
    }
}

export default function FamiliesRouter(): JSX.Element {

    return (
        <>
            <FamilyRoleBasedLayout>
                <FamiliesRoutes />
            </FamilyRoleBasedLayout>
        </>
    )
}
